module.exports = __webpack_public_path__ + "img/plus.029b2f8c.svg";